import React from "react";
import { Routes, Route } from "react-router-dom";

import Home from "./Home";
import Doors from "./Doors";
import AboutPage from "./Aboutpage";
import ContactPage from "./Contact";
import PrivacyPolicy from "./PrivacyPolicy";
import TermsConditions from "./TermsConditions";

import ScrollToTop from "../Components/ScrollToTop";
import ScrollToTopButton from "../Components/ScrollToTopButton";

const Routing = () => {
  return (
    <>
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/doors" element={<Doors />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsConditions />} />
      </Routes>

      <ScrollToTopButton />
    </>
  );
};

export default Routing;
